import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import useAsync from '#lib/hooks/use-async.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';

const md5 = require('md5');

const virtuousHostages = ['RU', 'AM', 'AZ', 'BL', 'KZ', 'KG', 'ML', 'TJ', 'TM', 'UZ', 'UA'];

async function fetchLogin({ data: body, country }) {
    if (body.connectionId !== 'virtuous' && virtuousHostages.some((el) => el === country))
        return _t.connections.russiaError();

    const authHeaders = await getAuthHeader();
    const response = await fetchAndParse(body.url, {
        method: 'POST',
        headers: { ...jsonHeaders },
        body: JSON.stringify({
            userName: body.username,
            password: md5(body.password || '')
        })
    });
    if (response.Errors) {
        return response.Errors.Error[0].Value;
    }

    const createConnectionResponse = await fetchAndParse(`${API_URL}/p/connection`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify({ connectionId: body.connectionId, token: response.Token })
    });

    return createConnectionResponse;
}

export function useLogin(options) {
    return useAsync(fetchLogin, options);
}
